import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SezioneDatiPignoramento } from 'src/app/common/models/sezioni/sezione-dati-pignoramento';
import { DatiPignoramentoAddComponent } from './dati-pignoramento-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [dati-pignoramento-mod-add]',
  templateUrl: 'dati-pignoramento-mod-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class DatiPignoramentoModAdd {
  @ViewChild('formAdd') formAdd: DatiPignoramentoAddComponent;
  @Output()
  onReturn: EventEmitter<SezioneDatiPignoramento> = new EventEmitter<SezioneDatiPignoramento>();

  inizializza(urlAddBene: string, idFascicolo: string, idSezione: string) {
    this.formAdd.inizializza(urlAddBene, idFascicolo, idSezione);
    openModal('modaladdDatiPignoramento');
  }

  createForm() {
    this.formAdd.createForm();
  }

  manageModal(sezione: SezioneDatiPignoramento) {
    closeModal('modaladdDatiPignoramento');
    this.onReturn.emit(sezione);
  }
}
